import { useEffect, useRef } from 'react';

export function useRelaxedInterval(callback: () => Promise<void> | void, delay: number | null) {
  const savedCallback = useRef<(() => Promise<void> | void) | undefined>(undefined);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    //running is local to each iteration of this effect
    //so won't pollute anything if the user starts polling again
    let running = false;
    let savedTimeout: ReturnType<typeof setTimeout> | null = null;

    const tick = async () => {
      if (running) {
        // @ts-expect-error savedCallback.current may be undefined
        await savedCallback.current();
      }

      if (running && delay !== null) {
        savedTimeout = setTimeout(tick, delay);
      }
    };

    const stop = () => {
      running = false;
      const timeout = savedTimeout;

      if (timeout !== null) {
        clearTimeout(timeout);
      }
    };

    if (delay !== null) {
      running = true;
      savedTimeout = setTimeout(tick, delay);
      return stop;
    }
  }, [delay]);
}
